import { scope } from "@otto-ec/global-resources/debug";

/**
 *
 *
 */
export const componentsScope = /*           */ scope("components");
